var path = '/pricingError.html';
var html = "<md-card class=has-circle-icon> <md-card-header> <md-card-header-text> <h1 class=\"md-title circle-icon error\">{{::route.title}}</h1> </md-card-header-text> </md-card-header> <md-card-content class=only-buttons> <div layout=row layout-align=center> <md-button class=\"md-primary md-raised\" ng-click=route.back() flex=100 flex-gt-xs=50> Go back </md-button> </div> </md-card-content> <md-card-content class=only-buttons ng-if=route.showEducatorContact> <div layout=row layout-align=center> <div>If you are an educator but do not have an valid educational email, please reach out to us at <a href=mailto:info@blippar.com>info@blippar.com</a></div> </div> </md-card-content> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./pricingError.html
// module id = 114
// module chunks = 0